import { useState, type FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/dagork1tto0ceqqni26g';

export default function SubscribeSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get('website_alt') as string) || '').trim();
    setLoading(true);
    try {
      if (honeypot !== '') {
        setStatus('success');
        setMessage('已收到你的关注请求，我们会在有新进展时与你同步。');
        form.reset();
        return;
      }
      fd.delete('website_alt');
      const payload = new URLSearchParams(fd as unknown as Record<string, string>);
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || text;
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('已收到你的关注请求，我们会在有新进展时与你同步。');
        form.reset();
      } else {
        setStatus('error');
        setMessage(serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后再试。');
    } finally {
      setLoading(false);
    }
  }

  return (
    <section id="subscribe" className="scroll-mt-16 bg-background-100">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 md:grid-cols-2 md:items-center md:px-6 md:py-16">
        <div>
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-notification-3-line text-sm"></i> 免费订阅
          </span>
          <h3 className="heading-font mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">不想错过后续进展？</h3>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            留下你的联系方式，当事件时间线有重大更新、关键澄清或新的核实结论时，我们会第一时间向你同步。
          </p>
        </div>
        <form data-readdy-form id="subscribe-form" onSubmit={handleSubmit} className="rounded-lg bg-background-50 p-5 md:p-6">
          <div className="flex flex-col gap-3">
            <input
              type="text"
              name="name"
              placeholder="怎么称呼你（可选）"
              autoComplete="name"
              className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
            />
            <input
              type="email"
              name="email"
              required
              placeholder="你的邮箱"
              autoComplete="email"
              className="w-full rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
            />
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="m-0 hidden h-0 w-0"
            />
            <textarea
              name="message"
              rows={2}
              maxLength={500}
              placeholder="想关注哪些事件进展？（可选，最多500字）"
              className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
            ></textarea>
            <button
              type="submit"
              disabled={loading}
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
            >
              {loading ? '提交中…' : '订阅关注进展'}
            </button>
          </div>
          {status === 'success' && <p className="mt-3 rounded-md bg-secondary-100 px-3 py-2 text-sm text-secondary-800">{message}</p>}
          {status === 'error' && <p className="mt-3 rounded-md bg-primary-100 px-3 py-2 text-sm text-primary-800">{message}</p>}
        </form>
      </div>
    </section>
  );
}